import { useEffect, useRef } from 'react';
export function useVisualViewport(onViewportUpdate, enabled) {
    var pendingUpdate = useRef(false);
    var supportsVisualViewport = typeof window !== 'undefined' && window.visualViewport;
    useEffect(function () {
        if (supportsVisualViewport && enabled) {
            onViewportUpdate(window.visualViewport);
        }
    }, [onViewportUpdate, supportsVisualViewport, enabled]);
    useEffect(function () {
        if (!supportsVisualViewport || !enabled) {
            return;
        }
        var viewportHandler = function (e) {
            if (pendingUpdate.current) {
                return;
            }
            pendingUpdate.current = true;
            requestAnimationFrame(function () {
                pendingUpdate.current = false;
                onViewportUpdate(e.target);
            });
        };
        window.visualViewport.addEventListener('scroll', viewportHandler);
        window.visualViewport.addEventListener('resize', viewportHandler);
        return function () {
            if (enabled) {
                window.visualViewport.removeEventListener('scroll', viewportHandler);
                window.visualViewport.removeEventListener('resize', viewportHandler);
            }
        };
    }, [pendingUpdate, onViewportUpdate, supportsVisualViewport, enabled]);
}
//# sourceMappingURL=useVisualViewport.js.map